import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../../systemSlice";
import { errorToHandler } from "../../../api/error";
import { rootCatApi } from "../../../api/catalog";
import { RootState } from "../../../app/store";
import { MinioCatalogUpdateFields } from "../../../api/catalogApi";

export const fetchCatalogDetailsHere = createAsyncThunk(
  "Catalog/fetchCatalogDetailsHere",
  async (
    {
      siteID,
      namespace,
      resourceID,
    }: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch },
  ) => {
    return rootCatApi.api

      .getCatalog(siteID, namespace, resourceID)
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const updateCatalogInstance = createAsyncThunk(
  "Catalog/updateCatalogInstance",

  async (
    requestElements: { siteID: string; namespace: string; resourceID: string },
    { rejectWithValue, dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const detailsToUpdate = state.catalog.details;
    const newFields: MinioCatalogUpdateFields = {
      volumeSize: detailsToUpdate?.volumeSize,
      storageClass: detailsToUpdate?.storageClass,
      minioUrl: detailsToUpdate?.minioUrl,
      accessKey: state.catalog.minioCredentials?.accesskey,
      secretKey: state.catalog.minioCredentials?.secretkey,
      env: detailsToUpdate?.env,
      nodeSelector: detailsToUpdate?.nodeSelector,
      tolerations: detailsToUpdate?.tolerations,
      resources: detailsToUpdate?.resources,
      image: detailsToUpdate?.image,
      imagePullPolicy: detailsToUpdate?.imagePullPolicy,
      imagePullSecrets: detailsToUpdate?.imagePullSecrets,
    };

    return rootCatApi.api
      .updateCatalog(
        requestElements.siteID,
        requestElements.namespace,
        requestElements.resourceID,
        {
          fields: newFields,
        },
      )
      .then(() => {
        dispatch(setSnackBarMessage("Updated Catalog Instance successfully"));
        dispatch(
          fetchCatalogDetailsHere({
            siteID: requestElements.siteID,
            namespace: requestElements.namespace,
            resourceID: requestElements.resourceID,
          }),
        );
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);
